import {computed, onUnmounted} from 'vue'
import {computedAsync} from '@vueuse/core'

/**
 * Image source composable
 */
export function useImageSource(src) {

  //Check what type of data we have gotten
  const isFile = computed(() => src.value instanceof File)

  //Image preview computed ref
  const imageSrc = computedAsync(async () => {
    if (!src.value) {
      return null
    }
    if (isFile.value) {
      return URL.createObjectURL(src.value)
    }
    return src.value
  }, null)

  //Revoke object URL on unmount
  onUnmounted(() => {
    if (isFile.value) {
      URL.revokeObjectURL(imageSrc.value)
    }
  })

  //Expose interface
  return {
    imageSrc,
  }
}
